import React from "react";

import { dollarDisplay } from "EmployerApplication/CostEstimationUtils";
import { isEqual } from "lodash";
import { OnChange } from "react-final-form-listeners";

import { Body1, Body2 } from "Cobalt/BodyText";
import { Row, Col } from "Common/Grid";
import { Div } from "Common/HTML";
import { SizeSwitch } from "Common/Responsive";

import CartEmployeeMockContributions from "./CartEmployeeMockContributions";

import makeBem from "Utils/makeBem";

const bem = makeBem("CartEmployeePriceBreakdown");

export const CartEmployeePriceBreakdownForm = ({
  medicalPlan,
  totals,
  contributionType,
  setContributions: { setContributionType, setEmployeeContribution, setDependentContribution },

  handleSubmit,
  dirty,
}) => {
  const handleContributionTypeToggle = (type) => {
    if (type == "percentage") {
      setEmployeeContribution(50);
      setDependentContribution(0);
    } else {
      setEmployeeContribution(0);
      setDependentContribution(0);
    }
    setContributionType(type);
  };

  const handleEmployeeContributionChange = (value, previous) => {
    if (dirty && !isEqual(value, previous)) {
      setEmployeeContribution(value);
    }
  };

  const handleDependentContributionChange = (value, previous) => {
    if (dirty && !isEqual(value, previous)) {
      setDependentContribution(value);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <SizeSwitch
        xs={
          <>
            <Row pb={2}>
              <Col xs={12}>
                <Body2>You Pay {medicalPlan?.carrier}</Body2>
              </Col>
            </Row>
            <Row pb={4}>
              <Col xs={12}>
                <Body2>
                  {dollarDisplay(totals.totalCost.toFixed(2))}
                  <Div pl={3} className={bem("perMonth")}>
                    Per Month
                  </Div>
                </Body2>
              </Col>
            </Row>
          </>
        }
        sm={
          <>
            <Row pb={4}>
              <Col sm={6}>
                <Body1>You Pay {medicalPlan?.carrier}</Body1>
              </Col>
              <Col sm={6}>
                <Body2 className="text-right">
                  {dollarDisplay(totals.totalCost.toFixed(2))}
                  <Div pl={3} className={bem("perMonth")}>
                    Per Month
                  </Div>
                </Body2>
              </Col>
            </Row>
            <Row pb={3}>
              <Col sm={6}>
                <Body2>Your Employee's Share</Body2>
              </Col>
              <Col sm={6}>
                <Body2 className="text-right">
                  {dollarDisplay(totals.totalEmployeeCost.toFixed(2))}
                  <Div pl={3} className={bem("perMonth")}>
                    Per Month
                  </Div>
                </Body2>
              </Col>
            </Row>
            <Row pb={5}>
              <Col sm={6}>
                <Body2>Your Company's Share</Body2>
              </Col>
              <Col sm={6}>
                <Body2 className="text-right">
                  {dollarDisplay(totals.totalCompanyCost.toFixed(2))}
                  <Div pl={3} className={bem("perMonth")}>
                    Per Month
                  </Div>
                </Body2>
              </Col>
            </Row>
          </>
        }
      />

      <Row>
        <Col sm={4}>
          <CartEmployeeMockContributions contributionType={contributionType} onToggle={handleContributionTypeToggle} />
        </Col>
      </Row>

      <OnChange name="employee_contribution">{handleEmployeeContributionChange}</OnChange>
      <OnChange name="dependent_contribution">{handleDependentContributionChange}</OnChange>
    </form>
  );
};

export default CartEmployeePriceBreakdownForm;
